import { render, staticRenderFns } from "./trocar.vue?vue&type=template&id=5bc0999a&"
import script from "./trocar.vue?vue&type=script&lang=js&"
export * from "./trocar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc0999a')) {
      api.createRecord('5bc0999a', component.options)
    } else {
      api.reload('5bc0999a', component.options)
    }
    module.hot.accept("./trocar.vue?vue&type=template&id=5bc0999a&", function () {
      api.rerender('5bc0999a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/trocar.vue"
export default component.exports